import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/Login";
import { API, formatApiError } from "@/lib/newsUtils";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Recuperar contraseña" subtitle="Te enviaremos un enlace para restablecerla.">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="flex items-center gap-2 text-primary">
            <MailCheck className="w-5 h-5" />
            <span className="font-semibold">Revisa tu correo</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Si ese correo tiene una cuenta, te hemos enviado instrucciones para restablecer la
            contraseña. El enlace caduca en 1 hora.
          </p>
          <Link to="/login" data-testid="back-to-login" className="text-primary font-semibold hover:underline text-sm">
            Volver a iniciar sesión
          </Link>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-xs uppercase tracking-wide font-semibold">Correo electrónico</Label>
              <Input id="email" type="email" data-testid="forgot-email" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="rounded-none border-border h-11" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
            <Button type="submit" data-testid="forgot-submit" disabled={loading}
              className="rounded-none bg-primary hover:bg-blue-900 w-full h-11 gap-2">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Enviar enlace
            </Button>
          </form>
          <p className="text-sm text-muted-foreground mt-6">
            <Link to="/login" className="text-primary font-semibold hover:underline">Volver a iniciar sesión</Link>
          </p>
        </>
      )}
    </AuthShell>
  );
}
